import { CommonComponent } from '@components/abstract/common-component.component';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Component } from '@angular/core';
import { Inject } from '@angular/core';
import { MigForm } from '@models/forms/mig-form.model';
import { ModelService } from '@services/common/model.service';
import { Subject } from 'rxjs';
import { WizardComponent } from 'angular-archwizard';

@Component({
  selector: 'app-mig-form',
  templateUrl: './mig-form.component.html',
  styleUrls: ['./mig-form.component.scss'],
  providers: [WizardComponent, CommonVerbsApiService],
})
export class MigFormComponent extends CommonComponent {
  activeStep = 0;
  formType: number | undefined;
  formCompleted = false;

  onNextSubject: Subject<void> = new Subject<void>();

  steps = [
    {
      index: 1,
      title: 'Initial Data',
    },

    {
      index: 2,
      title: 'Resident Name',
    },

    {
      index: 3,
      title: 'Form Type',
    },

    {
      index: 4,
      title: 'Form Move In',
    },
  ];

  constructor(
    @Inject('MigFormService')
    public service: ModelService<MigForm>
  ) {
    super();
  }

  nextStep() {
    this.formType = this.service.model?.formType;
    this.activeStep++;
    if (this.activeStep === 5) {
      this.formCompleted = true;
      localStorage.clear();
    }
    this.scrollTop();
  }

  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  backStep() {
    this.activeStep--;
    this.scrollTop();
  }

  onCreateNew() {
    this.resetForm();
    this.formCompleted = false;
    this.activeStep = 1;
  }

  resetForm() {
    this.service.set(null);
  }

  emitOnNext() {
    this.onNextSubject.next();
  }
}
